import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import { API_NON_ATTENDANCE_APPLICATIONS } from '@/api/endpoints';
import { NON_ATTENDANCE_APPLICATION_QUERY_KEY } from '@/api/queryKeys';
import { joinPath } from '@/utils/global';

export const useRetryCateringCancellation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) =>
      apiClient.put<unknown>(
        joinPath(
          joinPath(API_NON_ATTENDANCE_APPLICATIONS, String(id)),
          'catering',
        ),
      ),
    onSuccess: (_data, id) => {
      queryClient.invalidateQueries({
        queryKey: [...NON_ATTENDANCE_APPLICATION_QUERY_KEY, id],
      });
    },
  });
};
